import type { AxiosInstance, AxiosRequestConfig } from 'axios'

export const addInterceptor = (
  axiosInstance: AxiosInstance,
  interceptor: (config: AxiosRequestConfig) => AxiosRequestConfig,
) => {
  // @ts-expect-error
  return axiosInstance.interceptors.request.use(interceptor)
}

export const removeInterceptor = (axiosInstance: AxiosInstance, interceptorID: number) => {
  return axiosInstance.interceptors.request.eject(interceptorID)
}
